import EzDoubleRangeController from 'components/util/ez-double-range/ez-double-range-controller';

export default class DurationRangeController extends EzDoubleRangeController {
  connect() {
    super.connect();

    this.element.addEventListener('input', this.rangeChange);
    this.element.addEventListener('change', this.rangeChange);
  }

  disconnect() {
    super.disconnect();

    this.element.removeEventListener('input', this.rangeChange);
    this.element.removeEventListener('change', this.rangeChange);
  }

  setRangeDisplay = (leftValue, rightValue) => {
    this.displayLeftTarget.innerHTML = this.displaySecondsAsMinutes(leftValue);
    this.displayRightTarget.innerHTML = this.displaySecondsAsMinutes(rightValue);
  }

  displaySecondsAsMinutes = (seconds) => {
    const secondsRemainder = Math.floor(seconds % 60);
    const secondsPadded = secondsRemainder < 10 ? `0${secondsRemainder}` : secondsRemainder;

    return `${Math.floor(seconds / 60)}:${secondsPadded}`;
  }
}
